import { useState } from 'react';
import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { auth } from '../config/firebase';

function Settings() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (newPassword !== confirmPassword) {
      setStatus({ type: 'error', text: 'Las contraseñas nuevas no coinciden.' });
      return;
    }

    if (newPassword.length < 8) {
      setStatus({ type: 'error', text: 'La nueva contraseña debe tener al menos 8 caracteres.' });
      return;
    }

    if (newPassword === currentPassword) {
      setStatus({ type: 'error', text: 'La nueva contraseña debe ser distinta de la actual.' });
      return;
    }

    setLoading(true);
    try {
      const user = auth.currentUser;
      if (!user || !user.email) {
        throw new Error('No se pudo identificar al usuario actual.');
      }

      // Re-authenticate first
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);

      // Update password
      await updatePassword(user, newPassword);

      setStatus({ type: 'success', text: 'Contraseña actualizada correctamente.' });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      console.error(error);
      if (error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
        setStatus({ type: 'error', text: 'La contraseña actual es incorrecta.' });
      } else if (error.code === 'auth/too-many-requests') {
        setStatus({ type: 'error', text: 'Demasiados intentos. Por favor, inténtalo de nuevo más tarde.' });
      } else if (error.code === 'auth/weak-password') {
        setStatus({ type: 'error', text: 'La contraseña nueva es demasiado débil.' });
      } else {
        setStatus({ type: 'error', text: 'Ocurrió un error al actualizar la contraseña.' });
      }
    } finally {
      setLoading(false);
    }
  };

  const incomplete = !currentPassword || !newPassword || !confirmPassword;

  return (
    <div className="animate-fade-in">
      <div className="page-header">
        <div>
          <h1 className="page-title">Configuración</h1>
          <p className="page-subtitle">Tu cuenta de super administrador</p>
        </div>
      </div>

      <div className="card narrow-card">
        <div className="card-header"><h2 className="card-title">Cambiar contraseña</h2></div>
        <form onSubmit={handleChangePassword} className="card-body form-stack">
          <p className="text-secondary text-sm">
            Cuenta: <strong>{auth.currentUser?.email}</strong>. Por seguridad te pedimos la contraseña actual.
          </p>

          <label className="field">
            <span className="field-label">Contraseña actual</span>
            <input type="password" className="input-field" autoComplete="current-password"
              value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
          </label>

          <label className="field">
            <span className="field-label">Nueva contraseña</span>
            <input type="password" className="input-field" autoComplete="new-password" placeholder="Mínimo 8 caracteres"
              value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={8} />
          </label>

          <label className="field">
            <span className="field-label">Confirmar nueva contraseña</span>
            <input type="password" className="input-field" autoComplete="new-password"
              value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={8} />
          </label>

          {status && (
            <div className={`notice ${status.type === 'success' ? 'notice-success' : 'notice-error'}`} role="status">
              {status.text}
            </div>
          )}

          <button type="submit" className="btn btn-primary btn-lg" disabled={loading || incomplete}>
            {loading ? <><span className="spinner" /> Actualizando…</> : 'Actualizar contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Settings;
